import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DimensionsListenerDirective } from '@games/shared/game-dynamic-blocks/dimensions-listener.directive';
import { GameDynamicBlocksModule } from '@games/shared/game-dynamic-blocks/game-dynamic-blocks.module';
import { SpeedReadingResultBlockComponent } from './speed-reading-result-block/speed-reading-result-block.component';
import { SpeedReadingResultButtonComponent } from './speed-reading-result-button/speed-reading-result-button.component';
import { SpeedReadingResultComponent } from './speed-reading-result.component';
import { SpeedReadingResultFigureComponent } from './speed-reading-result-figure/speed-reading-result-figure.component';
import { TranslateModule } from '@ngx-translate/core';
import { SpeedReadingResultRowComponent } from './speed-reading-result-row/speed-reading-result-row.component';
import { SpeedReadingResultQuestionsComponent } from './speed-reading-result-questions/speed-reading-result-questions.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MobileTooltipTriggerDirective } from '@shared/directives';
import {HideOnNarrowWidthDirective} from "@pages/games/game/game-instance/hide-on-narrow-width.directive";

@NgModule({
  declarations: [
    SpeedReadingResultComponent,
    SpeedReadingResultBlockComponent,
    SpeedReadingResultButtonComponent,
    SpeedReadingResultFigureComponent,
    SpeedReadingResultRowComponent,
    SpeedReadingResultQuestionsComponent,
  ],
  exports: [
    SpeedReadingResultComponent,
    SpeedReadingResultBlockComponent,
    SpeedReadingResultButtonComponent,
    SpeedReadingResultFigureComponent,
    SpeedReadingResultRowComponent,
    SpeedReadingResultQuestionsComponent,
  ],
  imports: [
    CommonModule,
    TranslateModule,
    GameDynamicBlocksModule,
    DimensionsListenerDirective,
    MatTooltipModule, MobileTooltipTriggerDirective,
    HideOnNarrowWidthDirective,
  ],
})
export class SpeedReadingResultModule {}
